module.exports = __webpack_public_path__ + "img/wave.4332a2ee.svg";